/**
 * helpAnchors.js — puente entre la UI y la Academia.
 *
 * Cada «?» de la aplicación apunta a un ANCLA estable. El ancla no cambia
 * aunque el tema se renombre; aquí se traduce al id de tema real.
 *
 *   <HelpDot topic="racks.form" />   →  tema 'racks.form' de registry.js
 *
 * Regla: si un ancla no existe, HelpDot no pinta nada y el test
 * `registry.test.js` rompe la build. Nunca se deja un «?» huérfano.
 */

import { getTopic } from './registry';

export const HELP_ANCHORS = {
  // Menú y navegación
  'menu.sidebar': 'menu.order',
  'menu.customize': 'menu.hide',
  'menu.favorites': 'menu.favorites',

  // Racks
  'racks.list': 'racks.list',
  'racks.form': 'racks.form',
  'racks.designer': 'racks.designer',
  'racks.elements': 'racks.elements',

  // Listados (estándar común a todos los módulos)
  'listados.toolbar': 'listados.columns',
  'listados.rows': 'listados.rows',
  'listados.agent_activity': 'listados.agent_activity',
  'listados.agent_ad': 'listados.agent_ad',
  'listados.workstation_updates': 'listados.workstation_updates',
  'listados.workstation_performance': 'listados.workstation_performance',
  'listados.workstations': 'listados.workstations',
  'listados.workstation_inventory': 'listados.workstation_inventory',

  // Perfil
  'perfil.appearance': 'perfil.appearance',

  // Agente
  'agente.paquetes': 'agente.paquetes',

  // Planes de trabajo
  'planes.list': 'planes.pantalla',
  'planes.concept': 'planes.que-son',
  'planes.workstation': 'planes.que-son',
};

/** Devuelve el tema de un ancla, o null si el ancla está mal. */
export function resolveHelpAnchor(anchor) {
  const topicId = HELP_ANCHORS[anchor];
  return topicId ? getTopic(topicId) : null;
}
